<template>
    <div
        class="B2BServicesCard relative flex w-full flex-col p-5 sm:h-[357px] sm:w-[278px] lg:py-0"
        :class="{ 'border-b border-solid border-gray-200 dark:border-default lg:border-b-0 lg:border-r': data.haveBorder }"
    >
        <div class="mb-10 flex w-full flex-col sm:mb-2 sm:h-[250px]">
            <strong>{{ data.title }}</strong>

            <CText class="mt-5 leading-[27.2px]" variant="muted">
                {{ data.message }}
            </CText>
        </div>

        <div class="helped relative bottom-0 flex w-full flex-col">
            <CText class="mb-6" variant="muted">Už sme pomohli:</CText>

            <div v-if="data.variant === 'img'" class="img-wrap flex flex-row flex-wrap gap-5">
                <img
                    v-for="(imgName, index) in data.img"
                    :key="index"
                    :alt="imgName"
                    class="max-h-12 object-contain"
                    :src="`/images/coop/${imgName}.png`"
                />
            </div>

            <div v-else-if="data.variant === 'person'" class="img-wrap flex flex-row gap-5">
                <img
                    alt="data.img"
                    class="size-12 rounded-full object-contain"
                    :src="`/images/coop/${data.img}.png`"
                />

                <div class="flex flex-col justify-center">
                    <strong>
                        {{ data.person?.name }}
                    </strong>

                    <CText class="text-sm" variant="muted">
                        {{ data.person?.job }}
                    </CText>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CText from '@/components/ui/CText.vue'

interface PersonData {
    name: string
    job: string
}

interface CardData {
    title: string
    message: string
    variant: 'img' | 'person'
    img: string | string[]
    person?: PersonData
    haveBorder?: boolean
}

defineProps<{
    data: CardData
}>()
</script>